import { Button, Container, Grid2, useMediaQuery, useTheme } from "@mui/material";
import FullScreenModal from "components/common/FullScreenModal";
import { SMALL_DEVICE_MEDIA_SIZE } from "components/common/constants";
import log from "loglevel";
import React from "react";
import { FilmListForm, FilmListView } from "./container";
import "./styles.scss";
import {connect} from "react-redux";
import globalActions from "components/global/logic/actions";
import {actions} from "components/advertising/logic/formActions";
function FilmViewComponent({ onCloseGlobalSearch,  globalSearchOpen}) {
    const theme = useTheme();
    const isSmallDevice = useMediaQuery(theme.breakpoints.down(SMALL_DEVICE_MEDIA_SIZE));
    function onClearModal() {
        log.debug("todo cancel");
    }

    const searchForm = <FilmListForm isSmallDevice={isSmallDevice} />;
    const btnsModal = (
        <React.Fragment>
            { }
            <Button variant={"contained"} size={"small"} onClick={onClearModal} style={{ marginRight: 5 }}>
                Reset
            </Button>
            <Button variant={"contained"} size={"small"} color={"secondary"} onClick={onCloseGlobalSearch}>
                Search
            </Button>
        </React.Fragment>
    );
    return (
        (<Container maxWidth={"xl"} className={"atsGlobalContainer"}>
            <Grid2 container spacing={2}>
                <Grid2 sx={{ display: { sm: "none", xs: "none", md: "none", xl: "block", lg: "block" } }}
                    xlg={3}
                    size={{
                        md: 5,
                        lg: 3
                    }}>
                    {searchForm}
                </Grid2>

                <FullScreenModal btns={btnsModal} title={"Filter"} handleClose={onCloseGlobalSearch} open={globalSearchOpen}>
                    <Grid2 sx={{ display: { sm: "block", xs: "block", md: "block", xl: "none", lg: "none" } }}>
                        {searchForm}
                    </Grid2>
                </FullScreenModal>
                <Grid2
                    size={{
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 9,
                        xl: 9
                    }}>
                    <FilmListView />
                </Grid2>
            </Grid2>
        </Container>)
    );
}
const FilmView = connect(
    ({globalApp }) => ({
        globalSearchOpen: globalApp.globalSearchOpen,
    }),
    (dispatch) => ({
        onCloseGlobalSearch: () => dispatch(globalActions.TOGGLE_GLOBAL_SEARCH_BTN.call(false)),
        clearForm: () => dispatch(actions.CLEAR_FORM.call()),
        toggleAdvertisingForm: () => dispatch(actions.TOGGLE_ADVERTISING_FORM.send())}))(FilmViewComponent);
export default FilmView;
